<template>
  <div>
    <TableView
      :onRegister="onRegister"
      :onSearch="getFuncionario"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :tableData="tableData"
      :tableHead="tableHedad"
      :pagination="pagination"
      :response="response"
      :loadingTable="loadingTable"
      :loadingEditAll="loadingTable"
    />
  </div>
</template>

<script>

import Rest from "common/rest";
import TableView from 'common/table'

export default {
  components: {TableView},
  mixins: [Rest],
  data() {
    return {
      loadingTable:false,
      pagination:{},
      response:{},
      tableData: [],
      tableHedad: [
          {
            key: 'id',
            sortable: true,
            label: 'Cód',

          },
          {
            key: 'nome',
            sortable: true,
            label: 'Nome',

          },
          {
            key: 'cpf',
            sortable: true,
            label: 'CPF',

          },
          {
            key: 'funcao',
            sortable: true,
            label: 'Função',
          },
          {
            key: 'funcao',
            sortable: true,
            label: 'Função',
          },
          {
            key: 'status',
            sortable: true,
            label: 'Status',
          }
      ]
    };
  },
  beforeDestroy(){
		this.tableData = [];
	},
  created() {
  },

  mounted(){
	this.getFuncionario();
  },

  methods: {

    onRegister(){
      this.toRoute({name:'empresa.funcionario.cad'})
    },

    onEdit(data){
      this.toRoute({name: 'empresa.funcionario.edt',params:{id:data.id}});
    }, 
    
    onConsulta(data){
      this.toRoute(
        {name: 'empresa.consulta.cad',params:{funcionario:data.id}},'object'
      );
    },
    
    onDelete(data){
      
      var self = this;

      this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
          type: 'warning'

      }).then(() => {

        self.response = {};
        self.loadingTable = true;

        self.post('funcionario/0/deletar',{itens:data}).then((result) =>{
          result = result[0];

          self.loadingTable = false;

          self.response = result;

          if(result.status == 200){
            this.edMsg('REgistro(s) excluído(s) com sucesso');
            self.getFuncionario();
          }
        });
      });
    }, 

    getFuncionario(search,page,pagination) {

    this.loadingTable = true;

		this.get("funcionario/0",{search:search,page:page,pagination:pagination}).then(result => {
      result = result[0];
      
      this.loadingTable = false;
      this.response = result;

      var data = [], tableData = [], pagination = {};

			if(result.status == 200) {

        data = result.data.data;
 
        for (var i = 0; i < data.length; i++) {

          var item = {
            id: data[i].id,
            nome: data[i].nome,
            cpf: data[i].cpf,
            funcao: (data[i].funcao ? data[i].funcao.nome.toUpperCase() : null),
            status: (data[i].dem == 1 ? 'DEMITIDO' : 'ATIVO'),
            _data: data[i],
            options:{
              style:"color:"+(data[i].dem == 1 ? 'red' : ''),
            },
            buttons : [
              {
                color: 'warning',
                icon : 'fa fa-address-card',
                title: 'Inserir Nova Consulta',
                click : this.onConsulta

              }
            ]
          };

          tableData.push(item);
        }

        pagination = result.data;
      } 
      
       this.tableData = tableData;
       this.pagination = pagination;
		});
    },
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?6d10fe43